import { writable } from 'svelte/store';

const TYPEWRITER_INTERVAL_MS = 40;

export function createTypewriter() {
  let timer: ReturnType<typeof setInterval> | null = null;
  const name = writable('');

  function typewrite(text: string) {
    if (timer) clearInterval(timer);
    if (!text) { name.set('NO STATION'); return; }
    const chars = text.toUpperCase().split('');
    let result = '';
    let i = 0;
    name.set('');
    timer = setInterval(() => {
      result += chars[i] || '';
      name.set(result);
      i++;
      if (i >= chars.length) {
        if (timer) { clearInterval(timer); timer = null; }
      }
    }, TYPEWRITER_INTERVAL_MS);
  }

  function cleanup() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  return { name, typewrite, cleanup };
}
